<h2 class="text-center" mat-dialog-title>Ajouter un filleul</h2>
<div mat-dialog-content>
  <form [formGroup]="referralForm" (ngSubmit)="onSubmit()">
    <mat-form-field class="w-100">
      <mat-label>Nom</mat-label>
      <input matInput type="text" required formControlName="name" autocomplete="off" />
      <mat-error>
        @if (f('name').hasError('required')) {
          <span>Veuillez saisir le nom</span>
        }
        @if (f('name').hasError('maxlength')) {
          <span>Le nom est trop long</span>
        }
      </mat-error>
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>Prénom</mat-label>
      <input matInput type="text" required formControlName="firstName" autocomplete="off" />
      <mat-error>
        @if (f('firstName').hasError('required')) {
          <span>Veuillez saisir le prénom</span>
        }
        @if (f('firstName').hasError('maxlength')) {
          <span>Le prénom est trop long</span>
        }
      </mat-error>
    </mat-form-field>
    <mat-form-field class="w-100">
      <mat-label>E-mail</mat-label>
      <input matInput type="email" required formControlName="email" autocomplete="off" />
      <mat-error>
        @if (f('email').hasError('required')) {
          <span>Veuillez saisir l'e-mail</span>
        } @else if (f('email').hasError('email') || f('email').hasError('maxlength')) {
          <span>Veuillez saisir un e-mail valide</span>
        } @else if (f('email').hasError('notAllowed')) {
          <span>Ce contact ne peut pas être parrainé</span>
        }
      </mat-error>
    </mat-form-field>

    <div class="text-center">
      <button mat-flat-button class="m-2" color="primary" type="submit" [disabled]="formSubmitting">Ajouter</button>
      <button mat-flat-button class="m-2" color="primary" type="button" (click)="onNoClick()">Annuler</button>
    </div>
  </form>
</div>
